<div class="container-fluid">
  <div class="row h-100">
    <div class="col-8">
      <div class="login-card">
        <h1>New York State Workers' Compensation Board</h1>
      </div>
      <div class="login-card">
        <mat-card class="login-card">
          <mat-card-title>
            <h2 class="h3">Existing user?</h2>
          </mat-card-title>
          <mat-card-content>
            <button
              mat-flat-button
              color="primary"
              (click)="signIn()"
              data-automation-id="landing_202130144806"
            >
              Sign In
            </button>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="login-card">
        <mat-card class="login-card">
          <mat-card-title>
            <h2 class="h3">Don't have an account?</h2>
          </mat-card-title>
          <mat-card-content>
            If you are a new provider to the Medical Portal, you must first
            <a
              class="no-trailing-space"
              href="https://www.wcb.ny.gov/OnlineRegistration/onreg_medportal_confirmation.jsp"
            >
              sign up
            </a>
            for access to the Medical Portal. Otherwise, please contact your organization's
            administrator to sign up.
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
</div>
